import { settings } from '@/config/settings';
import permissionDirective from '@/directives/permission';
import { i18n, initLocale } from '@/i18n';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import ComonPagination from './components/ComonPagination.vue';
import router from './router';
import './styles/flex.css';
import './styles/index.css';
import './styles/module-common.scss';

const app = createApp(App);

app.config.globalProperties.$settings = settings;

app.component('ComonPagination', ComonPagination);
// 全局注册权限指令
app.directive('permission', permissionDirective);

const pinia = createPinia();
app.use(router);
app.use(pinia);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(i18n);
initLocale();

app.mount('#app');
